<div [ngClass]="{'mainContent':true, 'mobile':bMobile, 'desktop':!bMobile}">
  <div class="scan-info" *ngIf="dwtMounted">
    <div class="viewer-layout">
      <div class="thumbnail-sidebar" [class.hidden]="emptyBuffer">
        <div class="thumbnail-item" *ngFor="let item of thumbnailURLs; trackBy: trackByThumbnail"
          (click)="selectPage(item.index)" [class.active]="DWObject?.CurrentImageIndexInBuffer === item.index"
          draggable="true" (dragstart)="onDragStart($event, item.index)" (dragover)="onDragOver($event)"
          (drop)="onDrop($event, item.index)" (dragend)="onDragEnd($event)">
          <img [src]="item.url" alt="thumbnail">
          <div class="delete-icon-small" (click)="deletePage(item.index, $event)">
            <img src="../../../assets/Images/document-preview/trash.svg" alt="delete">
          </div>
          <span class="page-number-circle">{{item.index+1}}</span>
        </div>
      </div>
      <div id={{containerId}} class="dwt-viewer"></div>
    </div>
    <div class="options-container">
      <div class="modal-body">
        <ul class="list-group">
          <li class="list-group-item">
             <div class="documentType__dropdown">
              <div class="documentType__dropdownLabel">
                Device
              </div>
              <select class="docType__dropdownOptions"  id="device" [(ngModel)]="deviceName"
                (change)="handleDeviceChange('scanner')">
                <option selected>Choose...</option>
                <option *ngFor="let device of (devices | callback:isScannerFilter)">{{device.name}}</option>
              </select>
            </div>
          </li>
          <li class="list-group-item">
            <div class="input-group-prepend" style="display: flex;">
             
              <label class="input-group-text" style="width: 49%;margin-right: 2%;">
                <input type="checkbox" [(ngModel)]="scanOptions.IfFeederEnabled"
                  aria-label="Checkbox for ADF">&nbsp;&nbsp;AutoFeeder
              </label>
              <label class="input-group-text" style="width: 49%;">
                <input type="checkbox" [(ngModel)]="scanOptions.IfDuplexEnabled"
                  aria-label="Checkbox for Duplex">&nbsp;&nbsp;Duplex
              </label>
            </div>
          </li>
          <li class="list-group-item">
            <div class="input-group-prepend" style="display: flex;">
              <label class="input-group-text" style="width: 32%;margin-right: 2%;">
                <input type="radio" [(ngModel)]="scanOptions.PixelType" value=0
                  aria-label="Radio button for BW">&nbsp;&nbsp;B&amp;W
              </label>
              <label class="input-group-text" style="width: 32%;margin-right: 2%;">
                <input type="radio" [(ngModel)]="scanOptions.PixelType" value=1
                  aria-label="Radio button for Gray">&nbsp;&nbsp;Gray
              </label>
              <label class="input-group-text" style="width: 32%;">
                <input type="radio" [(ngModel)]="scanOptions.PixelType" value=2
                  aria-label="Radio button for RGB">&nbsp;&nbsp;Color
              </label>
            </div>
          </li>
          <li class="list-group-item">
            
            <div class="documentType__dropdown">
              <div class="documentType__dropdownLabel">
                Resolution
              </div>
              <select class="docType__dropdownOptions"  id="device" [(ngModel)]="scanOptions.Resolution">
                <option selected>Choose...</option>
                <option value="100">100</option>
                <option value="150">150</option>
                <option value="200">200</option>
                <option value="300">300</option>
              </select>
            </div>
          </li>
        </ul>
      <div class="modal-footer">
        <app-common-button buttonClass="smallFilledButton" [buttonLabel]="'Scan'" [typeBtn]="true" (clickEvent)="acquire()"
          custButtonClass="custButtonClass"></app-common-button>
        <app-common-button *ngIf="this.DWObject.HowManyImagesInBuffer > 0" buttonClass="ssoButton"
           [buttonLabel]="'Save As PDF'" (clickEvent)="saveAsPDF()"></app-common-button>
        <app-common-button *ngIf="this.DWObject.HowManyImagesInBuffer > 0" (clickEvent)="save()" buttonClass="ssoButton" [buttonLabel]="'Upload'">
        </app-common-button>
      </div>
      <div class="text-center" *ngIf="instantError">
        <small class="text-danger" >{{instantError}}</small>
      </div>
    </div>
    </div>
  </div>
  <div class="barcodeInfoRectContainer"
    *ngIf="barcodeReaderOptions.showRects && dwtMounted && barcodeRectsOnCurrentImage.length>0"
    [ngStyle]="{'position':'absolute', 'left':mainViewerPos.x + 'px','top':mainViewerPos.y +'px'}">
    <div class="barcodeInfoRect" *ngFor="let rect of barcodeRectsOnCurrentImage; let i = index"
      [ngStyle]="{'left': rect.x + 'px', 'top':rect.y + 'px', 'width':rect.w + 'px','height':rect.h + 'px'}">
      <div class="spanContainer"><span>{{i+1}}</span> </div>
    </div>
    <span style="font-size: large;">Barcode location indicators dissappearing in
      {{barcodeReaderOptions.rectShowingTime}}</span>
  </div>
  <div *ngIf="!dwtMounted" class="d-flex justify-content-center">
    <div class="spinner-border" role="status" style="margin:auto;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="controlPanel" *ngIf="dwtMounted">
  </div>
</div>

<ng-template tabindex="-1" #scannerModalRef role="dialog" aria-labelledby="acquireModalLabel" aria-hidden="true"
  let-acquireModal>
  <div class="modal-header">
    <h5 class="modal-title"><span>Scan A Document</span></h5>
    <button tabindex="-1" type="button" class="close" aria-label="Close" (click)="acquireModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ul class="list-group">
      <li *ngIf="showDevices" class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 18%;" for="device">Device</label>
          <select class="custom-select" style="width: 80%;" id="device" [(ngModel)]="deviceName"
            (change)="handleDeviceChange('scanner')">
            <option selected>Choose...</option>
            <option *ngFor="let device of (devices | callback:isScannerFilter)">{{device.name}}</option>
          </select>
        </div>
      </li>
      <li class="list-group-item">
        <div class="input-group-prepend" style="display: flex;">
          <label class="input-group-text" style="width: 32%;margin-right: 2%;">
            <input type="checkbox" [(ngModel)]="scanOptions.IfShowUI" aria-label="Checkbox for ShowUI">&nbsp;&nbsp;Show
            UI</label>
          <label class="input-group-text" style="width: 32%;margin-right: 2%;">
            <input type="checkbox" [(ngModel)]="scanOptions.IfFeederEnabled"
              aria-label="Checkbox for ADF">&nbsp;&nbsp;AutoFeeder
          </label>
          <label class="input-group-text" style="width: 32%;">
            <input type="checkbox" [(ngModel)]="scanOptions.IfDuplexEnabled"
              aria-label="Checkbox for Duplex">&nbsp;&nbsp;Duplex
          </label>
        </div>
      </li>
      <li class="list-group-item">
        <div class="input-group-prepend" style="display: flex;">
          <label class="input-group-text" style="width: 32%;margin-right: 2%;">
            <input type="radio" [(ngModel)]="scanOptions.PixelType" value=0
              aria-label="Radio button for BW">&nbsp;&nbsp;B&amp;W
          </label>
          <label class="input-group-text" style="width: 32%;margin-right: 2%;">
            <input type="radio" [(ngModel)]="scanOptions.PixelType" value=1
              aria-label="Radio button for Gray">&nbsp;&nbsp;Gray
          </label>
          <label class="input-group-text" style="width: 32%;">
            <input type="radio" [(ngModel)]="scanOptions.PixelType" value=2
              aria-label="Radio button for RGB">&nbsp;&nbsp;Color
          </label>
        </div>
      </li>
      <li class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 48%;" for="Resolution">Resolution</label>
          <select class="custom-select w-50" id="Resolution" [(ngModel)]="scanOptions.Resolution">
            <option selected>Choose...</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
            <option value="300">300</option>
          </select>
        </div>
      </li>
    </ul>
    <div class="alert alert-danger" style="margin:2% 0" role="alert" *ngIf="instantError">
      {{instantError}}</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" style="width:80%;" (click)="acquire()"><span>Scan</span></button>
  </div>
 
</ng-template>
<ng-template tabindex="-1" #cameraModalRef role="dialog" aria-labelledby="cameraModalLabel" aria-hidden="true"
  let-cameraModal>
  <div class="modal-header">
    <h5 class="modal-title">Capture from a Camera</h5>
    <button tabindex="-1" type="button" class="close" aria-label="Close" (click)="cameraModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ul class="list-group">
      <li *ngIf="showDevices" class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 20%;" for="device2">Device</label>
          <select class="custom-select" style="width: 80%;" id="device2" [(ngModel)]="deviceName"
            (change)="handleDeviceChange('camera')">
            <option selected>Choose...</option>
            
          </select>
        </div>
      </li>
      <li style="height:30vh">
        <div id={{videoContainerId}}></div>
      </li>
      <li *ngIf="cameraOptions.length>0 && bUseCameraViaDirectShow" class="list-group-item">
        <select [ngClass]="{'custom-select half':true}" [(ngModel)]="currentOption" (change)="handleOptionChange()">
          <option *ngFor="let cameraOption of cameraOptions">{{cameraOption.name}}</option>
        </select>
        <select [ngClass]="{'custom-select half':true}" [(ngModel)]="currentItem" (change)="handleItemPicked()">
          <option *ngFor="let item of currentOptionItems">{{item.value}}</option>
        </select>
      
      </li>
    </ul>
    <div class="alert alert-danger" style="margin:2% 0" role="alert" *ngIf="instantError">
      {{instantError}}</div>
  </div>
  <div *ngIf="showDevices" class="modal-footer" style="flex-direction: row;">
   
    <button type="button" class="btn btn-primary" style="width:48%;" (click)="acquireFromCamera()">Capture</button>
  </div>
</ng-template>
<ng-template tabindex="-1" #barcodeModalRef role="dialog" aria-labelledby="barcodeModalLabel" aria-hidden="true"
  let-barcodeModal>
  <div class="modal-header">
    <h5 class="modal-title">Read Barcode</h5>
    <button tabindex="-1" type="button" class="close" aria-label="Close" (click)="barcodeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body barcodeResultText" *ngIf="outputMessages.length>0">
    <button type="button" class="close" aria-label="Close" style="position: sticky; top:0"
      (click)="hideBarcodeTextResults()">
      <span aria-hidden="true">&times;</span>
    </button>
    <ul class="message">
      <li *ngFor="let outputMessage of outputMessages; let i = index" [ngClass]="outputMessage.type">
        {{outputMessage.text}}</li>
    </ul>
    <input type="checkbox" [(ngModel)]="barcodeReaderOptions.showRects"
      aria-label="Checkbox for show Rects">&nbsp;&nbsp;Show barcode locations on the image (3s).
  </div>
  <div class="modal-body" *ngIf="outputMessages.length===0">
    <ul class="list-group">
      <li class="list-group-item">
        <h6><input type="checkbox" (click)="toggleCheckAll()" [(ngModel)]="barcodeReaderOptions.Symbologies.All"
            aria-label="Checkbox for check|uncheck all">&nbsp;&nbsp;Barcode Types:
        </h6>
        <div class="input-group-prepend barcodeReaderOptions">
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Linear" name="BarcodeType"
              aria-label="Checkbox for Linear Barcodes" value="0x3FF">&nbsp;&nbsp;
            Linear
            &nbsp;&nbsp;<img id="linearToolTip" src="assets/imgs/barcode/oned.gif" title="" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.QRCode" name="BarcodeType"
              aria-label="Checkbox for QRCode" value="0x4000000">&nbsp;&nbsp;
            QRCode
            &nbsp;&nbsp;<img id="qrCodeToolTip" src="assets/imgs/barcode/qr.gif" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Pdf" name="BarcodeType"
              aria-label="Checkbox for PDF417" value="0x2000000">&nbsp;&nbsp;
            PDF417
            &nbsp;&nbsp;<img id="pdf417ToolTip" src="assets/imgs/barcode/pdf417.gif" title="" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.DM" name="BarcodeType"
              aria-label="Checkbox for DataMatrix" value=" 0x8000000">&nbsp;&nbsp;
            DataMatrix
            &nbsp;&nbsp;<img id="dmToolTip" src="assets/imgs/barcode/dm.gif" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Aztec" name="BarcodeType"
              aria-label="Checkbox for Aztec Code" value=" 0x10000000">&nbsp;&nbsp;
            Aztec
            &nbsp;&nbsp;<img id="aztecToolTip" src="assets/imgs/barcode/aztec.gif" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.GS1Databar" name="BarcodeType"
              aria-label="Checkbox for GS1 DataBar" value=" 0x3F800">&nbsp;&nbsp;
            Databar
            &nbsp;&nbsp;<img id="gs1DatabarToolTip" src="assets/imgs/barcode/gs1databar.png" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Maxi" name="BarcodeType"
              aria-label="Checkbox for Maxicode" value=" 0x20000000">&nbsp;&nbsp;
            Maxicode
            &nbsp;&nbsp;<img id="maxiToolTip" src="assets/imgs/barcode/maxicode.png" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Patch" name="BarcodeType"
              aria-label="Checkbox for Patch Code" value=" 0x40000">&nbsp;&nbsp;
            Patch
            &nbsp;&nbsp;<img id="patchToolTip" src="assets/imgs/barcode/patchcode.png" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Postal" name="BarcodeType2"
              aria-label="Checkbox for Postal Code" value=" 0x1F00000">&nbsp;&nbsp;
            Postal
            &nbsp;&nbsp;<img id="postalToolTip" src="assets/imgs/barcode/postalcode.png" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.Dot" name="BarcodeType2"
              aria-label="Checkbox for DotCode" value="0x2">&nbsp;&nbsp;
            DotCode
            &nbsp;&nbsp;<img id="dotToolTip" src="assets/imgs/barcode/dotcode.png" alt="barcode"></label>
          <label class="input-group-text">
            <input type="checkbox" [(ngModel)]="barcodeReaderOptions.Symbologies.GS1Composite" name="BarcodeType"
              aria-label="Checkbox for GS1 Composite" value=" 0xFFFFFFFF80000000">&nbsp;&nbsp;
            Composite
            &nbsp;&nbsp;<img id="gs1CompositeToolTip" src="assets/imgs/barcode/gs1composite.png" alt="barcode"></label>
        </div>
      </li>
      <li class="list-group-item">
        <h6>Barcode Mode:</h6>
        <div class="input-group-prepend" style="display: flex;">
          <label class="input-group-text barcodeReadMode" style="width: 32%;margin-right: 2%; ">
            <input type="radio" [(ngModel)]="barcodeReaderOptions.Mode" value="speed"
              aria-label="Radio button for Speed">&nbsp;&nbsp;Speed
          </label>
          <label class="input-group-text barcodeReadMode" style="width: 32%;margin-right: 2%;">
            <input type="radio" [(ngModel)]="barcodeReaderOptions.Mode" value="balance"
              aria-label="Radio button for Balance">&nbsp;&nbsp;Balance
          </label>
          <label class="input-group-text barcodeReadMode" style="width: 32%;">
            <input type="radio" [(ngModel)]="barcodeReaderOptions.Mode" value="coverage"
              aria-label="Radio button for Coverage">&nbsp;&nbsp;Coverage
          </label>
        </div>
      </li>
    </ul>
    <div class="alert alert-danger" style="margin:2% 0" role="alert" *ngIf="instantError">{{instantError}}</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" style="width:80%;"
      [disabled]="emptyBuffer || barcodeButtonText==='Reading...'"
      (click)="readBarcode()">{{barcodeButtonText}}</button>
  </div>
</ng-template>
<ng-template tabindex="-1" #saveModalRef role="dialog" aria-labelledby="saveModalLabel" aria-hidden="true"
  let-saveModal>
  <div class="modal-header">
    <h5 class="modal-title">{{saveOptions.buttonText}}</h5>
    <button tabindex="-1" type="button" class="close" aria-label="Close" (click)="saveModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ul class="list-group">
      <li class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 40%;" for="outPutType">Type:</label>
          <select class="custom-select" style="width: 60%;" id="outPutType" (ngModelChange)="outPutTypeChanged($event)"
            [(ngModel)]="saveOptions.outPutType">
            <option>File</option>
            <option>Blob</option>
            <option>Base64</option>
          </select>
        </div>
      </li>
      <li class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 40%;" for="outPutFormat">Format:</label>
          <select class="custom-select" style="width: 60%;" id="outPutFormat" [(ngModel)]="saveOptions.outPutFormat"
            (ngModelChange)="handleOutPutFormatChange($event)">
            <option>BMP</option>
            <option>JPG</option>
            <option>TIF</option>
            <option>PNG</option>
            <option>PDF</option>
          </select>
        </div>
      </li>
      <li *ngIf="saveOptions.outPutType === 'File'" class="list-group-item">
        <div class="input-group-prepend">
          <label class="input-group-text" style="width: 40%;" for="fileName">File Name:</label>
          <input type="text" class="custom-select" style="width: 60%;" id="fileName"
            [(ngModel)]="saveOptions.fileName" />
        </div>
      </li>
      <li *ngIf="saveOptions.outPutType === 'File'" class="list-group-item">
        <label class="input-group-text" style="width: 100%;">
          <input type="checkbox" [(ngModel)]="saveOptions.upload" aria-label="Checkbox for upload"
            (ngModelChange)="outPutTypeChanged('File')">&nbsp;&nbsp;Upload To
          Server</label>
      </li>
      <li class="list-group-item"
        *ngIf="(saveOptions.outPutFormat === 'TIF' || saveOptions.outPutFormat === 'PDF') && !emptyBuffer">
        <label class="input-group-text" style="width: 100%;">
          <input type="checkbox" [(ngModel)]="saveOptions.multiPage" (ngModelChange)="handleMultiPageCheck()"
            aria-label="Checkbox for multiPage">&nbsp;&nbsp;Multi-Page&nbsp;&nbsp;</label>
      </li>
      <li
        *ngIf="saveOptions.multiPage && saveOptions.indices.length>0 && (saveOptions.outPutFormat === 'TIF' || saveOptions.outPutFormat === 'PDF')"
        class="list-group-item" style="display:flex; overflow-x: auto; overflow-y: hidden; margin: 0 5%;">
        <label *ngFor="let index of saveOptions.indices" class="input-group-text" style="width: 20%; margin-right: 3%;">
          <input type="checkbox" [(ngModel)]="index.selected"
            (ngModelChange)="handleIndexSelection($event,index.number)"
            aria-label="Checkbox for targetIndices">&nbsp;&nbsp;{{index.number+1}}</label>
      </li>
      <li class="list-group-item" style="max-height: 25vh; overflow-y:auto;"
        *ngIf="saveResults.savedFiles.length>0 ||saveResults.uploadedFiles.length>0 ||saveResults.blobURL.length>0||saveResults.base64String.length>0">
        
        <button *ngFor="let url of saveResults.blobURL; let i = index" class="btn btn-success w-100 mb-2"
          (click)="copyURLToShow(url)">{{saveResults.blob[i].name}}</button>
        <button *ngFor="let file of saveResults.savedFiles; let i=index" class="btn btn-success w-100 mb-2"
          (click)="copyFilePath(i)">{{saveResults.saveFileText[i]}}</button>
        <button *ngFor="let string of saveResults.base64String; let i = index" class="btn btn-success w-100 mb-2"
          (click)="copyBase64String(i)">{{saveResults.base64ButtonText[i]}}</button>
      </li>
    </ul>
    <div class="alert alert-danger" style="margin:2% 0" role="alert" *ngIf="instantError">{{instantError}}</div>
  </div>
  <div class="modal-footer">
    <button type="button" style="width:80%;" [disabled]="emptyBuffer" class="btn btn-primary"
      (click)="save()">{{saveOptions.buttonText}}</button>
  </div>
</ng-template>
<hr>